import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-center q-pa-lg"
}
const _hoisted_2 = {
  key: 1,
  class: "row q-gutter-md justify-center waveform-preview-row"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-caption text-center text-bold q-mb-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    persistent: "",
    onHide: _ctx.onHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"min-width":"400px","max-width":"90vw"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "text-h6" }, "Select Waveform to Verify", -1),
              _createElementVNode("div", { class: "text-body2 q-mt-sm" }, " Click a waveform to select it, then press OK. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_q_spinner_dots, {
                      color: "primary",
                      size: "40px"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previews, (wf) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: wf.passageWaveformId,
                        class: _normalizeClass(["waveform-preview-card", {
              'waveform-preview-selected': _ctx.selectedId === wf.passageWaveformId,
            }]),
                        onClick: ($event: any) => (_ctx.selectedId = wf.passageWaveformId)
                      }, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getLabel(wf.passageWaveformType)), 1),
                        _createElementVNode("canvas", {
                          ref_for: true,
                          ref: 'wfCanvas_' + wf.passageWaveformId,
                          width: "160",
                          height: "90",
                          class: "waveform-preview-canvas"
                        }, null, 512)
                      ], 10, _hoisted_3))
                    }), 128))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Cancel",
                class: "btn-brand",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"]),
              _createVNode(_component_q_btn, {
                flat: "",
                label: "OK",
                class: "btn-brand",
                color: "primary",
                disable: _ctx.selectedId === null,
                onClick: _ctx.onConfirm
              }, null, 8, ["disable", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onHide"]))
}